export default "__VITE_ASSET__2yO4ecy8__"